import {createStore as createReduxStore, applyMiddleware, compose} from 'redux';
import thunk from 'redux-thunk';
import {persistStore, persistReducer} from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import reducers from './reducers';

const middleWares = [thunk].filter(Boolean);

const persistConfig = {
	key: 'root',
	storage,
	whitelist: ['general'],
};

const composeEnhancers =
	(typeof window !== 'undefined' &&
		process.env.NODE_ENV !== 'production' &&
		window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
	compose;

const enhancer = composeEnhancers(applyMiddleware(...middleWares));

const persistedReducer = persistReducer(persistConfig, reducers);

const createStore = () => {
	let store = createReduxStore(persistedReducer, undefined, enhancer);
	let persistor = persistStore(store);
	return {store, persistor};
};

export default createStore;
